module.exports = __webpack_public_path__ + "img/symbol_10.837d4e02.png";